const productAttrProps = {
  整体业绩_不含素金: "salesNum",
  整体业绩: "salesNum2",
  组内占比_不含素金: "zb",
  组内占比: "zb2",
};

export default productAttrProps;
